// request.js文件
import axios from 'axios';
import store from '../store/store';
import router from '../router';
import { Loading } from 'element-ui';
import { Message } from 'element-ui';
// import { Notification, MessageBox, Message, Loading } from 'element-ui'
// import store from '@/store'
// 引入基础参数文件  和  baseURL配置文件
// import { BASE_URL } from './config'   // baseURL写在config.js文件中
const request = axios.create({
  baseURL: window.glob.baseURL,
  timeout: 10000
});
// 添加请求拦截器
request.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    (config.headers.Authorization = store.state.m_user.token),
      Loading.service({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0)'
      });

    // setTimeout(() => {
    //   let loadingInstance = Loading.service({
    //     lock: true,
    //     text: 'Loading',
    //     spinner: 'el-icon-loading',
    //     background: 'rgba(0, 0, 0, 0.7)'
    //   });
    //   alert('网络出错,请检查网络!')
    //     loadingInstance.close();
    // }, 15000);

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// 添加响应拦截器
request.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    let loadingInstance = Loading.service({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0)'
    });
    loadingInstance.close();

    setTimeout(() => {
      if (response.data.code == 401) {
        if (localStorage.getItem('url')) {
          window.location.replace(localStorage.getItem('url'));
        } else {
          window.location.replace('https://www.ahsjxjy.com/studyMain');
        }
      }
    }, 1000);
    return response;
  },
  function (error) {
    // 对请求错误做些什么
    let { message } = error;
    let loadingInstance = Loading.service({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0)'
    });
    if (message == 'Network Error') {
      loadingInstance.close();
      message = '后端接口连接异常';
    } else if (message.includes('timeout')) {
      loadingInstance.close();
      message = '系统接口请求超时';
    } else if (message.includes('Request failed with status code')) {
      loadingInstance.close();
      message = '系统接口' + message.substr(message.length - 3) + '异常';
    }
    loadingInstance.close();
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    });
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default request;
